import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery } from 'shared/components';
/**

* Hides or displays content when printing

 *
 */
var PrintWrapper = function (_a) {
    var children = _a.children, hideWhenPrint = _a.hideWhenPrint;
    var isPrint = useMediaQuery('print')[0];
    if ((isPrint && !hideWhenPrint) || (!isPrint && hideWhenPrint))
        return _jsx(_Fragment, { children: children });
    return null;
};
// Print the window, set timeout is there to put the print funtion in the event loop, to ensure that it happens after a re-render
var PrintWithDelay = function () {
    setTimeout(function () {
        window.print();
    }, 0);
};
export { PrintWrapper, PrintWithDelay };
